import { render, staticRenderFns } from "./KioskBranded.vue?vue&type=template&id=2cad1b76&scoped=true&lang=pug"
import script from "./KioskBranded.vue?vue&type=script&lang=js"
export * from "./KioskBranded.vue?vue&type=script&lang=js"
import style0 from "./KioskBranded.vue?vue&type=style&index=0&id=2cad1b76&prod&lang=scss"
import style1 from "./KioskBranded.vue?vue&type=style&index=1&id=2cad1b76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cad1b76",
  null
  
)

export default component.exports